<script setup>
import { computed } from 'vue';
import { getSignalInfo } from './useIspStatusStyles';

const props = defineProps({
  dBm: { type: [Number, String], default: null },
});

const signal = computed(() => getSignalInfo(props.dBm));
</script>

<template>
  <div class="flex-1 min-w-0">
    <div class="flex items-center justify-between mb-0.5">
      <span class="text-[11px] text-n-slate-10">{{ signal.qualityLabel }}</span>
      <span class="text-[11px] text-n-slate-12 font-medium font-mono">
        {{ signal.label }}
      </span>
    </div>
    <div class="h-[5px] bg-n-slate-3 rounded-full overflow-hidden">
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="signal.color"
        :style="{ width: signal.percent + '%' }"
      />
    </div>
  </div>
</template>
